<template>
  <div class="layout-search-bar-column">
    <hr class="suggestions-mobile-divider" />
    <div class="suggestions-product-heading">
      <h6>{{ title }}</h6>
      <template v-if="isShowAllVisible">
        <span class="dash"> — </span>
        <reloading-router-link :to="showAllRoute" class="suggestions-show-all" @click="onExit"> Show All </reloading-router-link></template
      >
    </div>
    <slot name="default"></slot>
  </div>
</template>

<script>
export default { name: 'SearchBarColumn' };
</script>

<script setup>
import { ref, computed, watch, inject } from 'vue';
import ReloadingRouterLink from '@/components/commons/ReloadingRouterLink.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  isShowAllVisible: {
    type: Boolean,
    required: false,
    default: false,
  },
  showAllRoute: {
    type: Object,
    required: false,
    default: null,
  },
});

const onExit = inject('onExit');
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

h6 {
  padding-right: var(--space-1);
}

.layout-search-bar-column {
  padding-right: var(--space-10);

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    padding-right: 0;
  }
}

.suggestions-product-heading {
  padding-bottom: var(--space-4);
  margin-bottom: var(--space-4);
  border-bottom: 1px solid var(--grey-light);
}

.suggestions-split-container.help-center-page-search {
  display: block;
  .suggestions,
  .suggestions-right-column {
    width: 100%;
    padding-right: 0;
  }
}

.dash {
  color: var(--grey-light);
}

.suggestions-mobile-divider {
  display: none;
  margin-top: 10px;
  margin-bottom: 10px;

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    display: block;
  }
}

.layout-search-bar-column:first-child .suggestions-mobile-divider {
  display: none;
}

.suggestions-show-all {
  font-size: var(--font-size-14);
  line-height: var(--font-size-14);
  color: var(--coral);
  text-decoration: underline;
  margin-left: var(--space-1);
}

.suggestions-product-heading {
  display: flex;
  align-items: baseline;
}
</style>
